import { useCallback, useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { api } from '../../services/api';
import PaymentProviderDisconnectModal from './PaymentProviderDisconnectModal';

const PayPalDisconnectModal = ({ open, onClose, onSuccess }) => {
  const { storeId } = useContext(AppContext);

  const onDisconnect = useCallback(async () => {
    if (storeId == null) {
      throw new Error('Store is not available.');
    }
    await api.deactivatePayPal(storeId);
  }, [storeId]);

  return (
    <PaymentProviderDisconnectModal
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
      providerLabel="PayPal"
      onDisconnect={onDisconnect}
    />
  );
};

export default PayPalDisconnectModal;
